import React from "react";
import { useTranslation } from "react-i18next";

import { COMMON_KEYWORDS } from "./consts";
import Checkbox from "../../../../../FormElement/Checkbox";

import "./styles.scss";

interface ICommonKeywordsSelectProps {
  selectedKeywords: string[];
  setSelectedKeywords: (keywords: string[]) => void;
}

export const CommonKeywordsSelect = ({
  selectedKeywords,
  setSelectedKeywords,
}: ICommonKeywordsSelectProps) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`internaltoolsPage.checkOwnerArea.${key}`);

  const handleCheckKeyword = (keyword: string, checked: boolean) => {
    if (checked) {
      const newSelectedKeywords = [...selectedKeywords, keyword];
      setSelectedKeywords(newSelectedKeywords);
    } else {
      const newSelectedKeywords = selectedKeywords.filter((k) => k !== keyword);
      setSelectedKeywords(newSelectedKeywords);
    }
  };

  const handleSelectAll = () => {
    setSelectedKeywords(COMMON_KEYWORDS);
  };
  const handleSelectNone = () => {
    setSelectedKeywords([]);
  };

  return (
    <div className="common-keywords-select">
      <div className="common-keywords-select-header">
        <h3>{t("common_keywords_title")}</h3>
        <div className="common-keywords-select-header-buttons">
          <button className="btn btn-border" onClick={handleSelectAll}>
            {t("select_all")}
          </button>
          <button
            className="btn btn-border btn-border-red"
            onClick={handleSelectNone}
          >
            {t("select_none")}
          </button>
        </div>
      </div>
      <div className="common-keywords-list">
        {COMMON_KEYWORDS.map((keyword) => (
          <Checkbox
            key={keyword}
            label={keyword}
            checked={selectedKeywords.includes(keyword)}
            onChange={(checked) => handleCheckKeyword(keyword, checked)}
            id={keyword}
          />
        ))}
      </div>
    </div>
  );
};
